var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIsrael(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.874C24.8366 32.874 32 25.7106 32 16.874C32 8.03747 24.8366 0.874023 16 0.874023C7.16344 0.874023 0 8.03747 0 16.874C0 25.7106 7.16344 32.874 16 32.874Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.0241 13.3955H18.0077L15.9995 9.91725L13.9915 13.3955H9.97498L11.9834 16.8738L9.97498 20.352H13.9915L15.9995 23.8303L18.0077 20.352H22.0241L20.0157 16.8738L22.0241 13.3955ZM18.4667 16.8738L17.2332 19.0105H14.766L13.5324 16.8738L14.766 14.737H17.2332L18.4667 16.8738ZM15.9995 12.6002L16.4587 13.3954H15.5405L15.9995 12.6002ZM12.2987 14.737H13.2169L12.7578 15.5323L12.2987 14.737ZM12.2987 19.0105L12.7579 18.2153L13.217 19.0105H12.2987ZM15.9995 21.1473L15.5405 20.352H16.4587L15.9995 21.1473ZM19.7004 19.0105H18.7822L19.2414 18.2153L19.7004 19.0105ZM18.7822 14.737H19.7004L19.2413 15.5323L18.7822 14.737Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.9596 4.35195H6.03996C4.57977 5.51495 3.32752 6.92758 2.34814 8.52589H29.6514C28.672 6.92764 27.4197 5.51495 25.9596 4.35195V4.35195Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.03996 29.3954H25.9595C27.4197 28.2324 28.672 26.8197 29.6513 25.2214H2.34814C3.32758 26.8197 4.57983 28.2324 6.03996 29.3954V29.3954Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.874023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsrael);
export default __webpack_public_path__ + "static/media/israel.447ca61c.svg";
export { ForwardRef as ReactComponent };